import { stdObject } from "../../../../data/types/stdObject";
import { toPrice } from "../../../../utils/toPrice";

export const salesCommData = (sectionArea: stdObject) => {
  return sectionArea.commissions.map((e: stdObject) => {
    sectionArea.paymentCommList.forEach((v: stdObject) => {
      if (typeof e[v.code] === "number") {
        e[v.code] = toPrice(e[v.code]);
      }
    });
    return e;
  });
};
